import React from 'react';

const DataProtection = () => (
    <div className="container mt-5">
        <div className="row">
            <div className="col-12">
                <h2>Datenschutzerklärung</h2>

                <p className="mt-5">
                    <b>Allgemeine Hinweise</b>
                </p>
                <p>
                    Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG).
                    In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.
                </p>

                <p className="mt-4">
                    <b>Verantwortlicher für die Datenverarbeitung</b>
                </p>
                <p>
                    Backslash Seven GmbH<br/>
                    Großbeerenstr. 12<br/>
                    10963 Berlin<br/>
                    Deutschland<br/>
                    E-Mail: <a href="mailto:mail@backslashseven.de">mail@backslashseven.de</a><br/>
                    Telefon: 030 20006764
                </p>

                <p className="mt-4">
                    <b>Hosting</b>
                </p>
                <p>
                    Diese Website wird auf einer eigenen Kubernetes-Infrastruktur der Backslash Seven GmbH betrieben. Die zugrundeliegenden virtuellen Maschinen (VMs) befinden sich in einem Rechenzentrum der Hetzner Online GmbH in Deutschland.
                    <br/>
                    Die Datenverarbeitung erfolgt ausschließlich auf Servern innerhalb der Europäischen Union (EU).
                </p>

                <p className="mt-4">
                    <b>Server-Logfiles</b>
                </p>
                <p>
                    Beim Aufruf dieser Website werden automatisch Informationen erfasst und in sogenannten Server-Logfiles gespeichert.
                    Diese Informationen beinhalten:
                </p>
                <ul>
                    <li>Browsertyp und Browserversion</li>
                    <li>Verwendetes Betriebssystem</li>
                    <li>Referrer URL</li>
                    <li>Hostname des zugreifenden Rechners</li>
                    <li>Uhrzeit der Serveranfrage</li>
                    <li>IP-Adresse (gekürzt oder anonymisiert, sofern möglich)</li>
                </ul>
                <p>
                    Diese Daten sind nicht bestimmten Personen zuordenbar und werden nicht mit anderen Datenquellen zusammengeführt.
                    Die Speicherung erfolgt aus Sicherheitsgründen, z. B. um Missbrauchsfälle aufzuklären.
                </p>

                <p className="mt-4">
                    <b>TLS-Verschlüsselung (HTTPS)</b>
                </p>
                <p>
                    Diese Website verwendet HTTPS zur sicheren Datenübertragung im Internet. Durch den Einsatz von TLS (Transport Layer Security) werden vertrauliche Daten geschützt.
                    Sie erkennen die verschlüsselte Verbindung an der Adresszeile Ihres Browsers („https://“) und dem Schloss-Symbol.
                </p>

                <p className="mt-4">
                    <b>Keine Cookies, kein Tracking</b>
                </p>
                <p>
                    Diese Website verwendet keine Cookies und keine Analysetools wie Google Analytics oder vergleichbare Dienste.
                    Es werden keine personenbezogenen Daten zu Marketingzwecken erfasst.
                </p>

                <p className="mt-4">
                    <b>Kontaktaufnahme per E-Mail</b>
                </p>
                <p>
                    Wenn Sie per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zur Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                    Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>

                <p className="mt-4">
                    <b>Ihre Rechte gemäß DSGVO</b>
                </p>
                <p>
                    Sie haben gemäß DSGVO das Recht auf:
                    <br/><br/>
                    • Auskunft (Art. 15)<br/>
                    • Berichtigung (Art. 16)<br/>
                    • Löschung (Art. 17)<br/>
                    • Einschränkung der Verarbeitung (Art. 18)<br/>
                    • Datenübertragbarkeit (Art. 20)<br/>
                    • Widerspruch gegen die Verarbeitung (Art. 21)<br/>
                    • Widerruf einer Einwilligung (Art. 7 Abs. 3)<br/>
                </p>
                <p>
                    Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt, können Sie sich bei einer Aufsichtsbehörde beschweren. Zuständig für Berlin ist:
                </p>
                <p>
                    Berliner Beauftragte für Datenschutz und Informationsfreiheit<br/>
                    Alt-Moabit 59–61<br/>
                    10555 Berlin<br/>
                    <a href="https://www.datenschutz-berlin.de/" target="_blank" rel="noopener noreferrer">https://www.datenschutz-berlin.de/</a>
                </p>

                <p className="mt-4 text-muted">
                    © {new Date().getFullYear()} Backslash Seven GmbH – Alle Rechte vorbehalten.
                </p>
            </div>
        </div>
    </div>
);

export default DataProtection;